module.exports = __webpack_public_path__ + "img/video_poster.e7cffbc7.png";